import { render, staticRenderFns } from "./Introduction.vue?vue&type=template&id=2400fd5c&"
import script from "./Introduction.vue?vue&type=script&lang=js&"
export * from "./Introduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2400fd5c')) {
      api.createRecord('2400fd5c', component.options)
    } else {
      api.reload('2400fd5c', component.options)
    }
    module.hot.accept("./Introduction.vue?vue&type=template&id=2400fd5c&", function () {
      api.rerender('2400fd5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/common/dashboard/panels/Introduction.vue"
export default component.exports